import React, { useState, useEffect } from "react";
import axios from "axios";

const CorsTest = () => {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState({
    withCredentials: null,
    withoutCredentials: null,
  });
  const [error, setError] = useState(null);
  const [logs, setLogs] = useState([]);

  const addLog = (message) => {
    setLogs((prevLogs) => [
      ...prevLogs,
      `${new Date().toISOString()}: ${message}`,
    ]);
  };

  useEffect(() => {
    testCors();
  }, []);

  const testCors = async () => {
    setLoading(true);
    setError(null);
    setResults({
      withCredentials: null,
      withoutCredentials: null,
    });

    const baseURL = "https://lioncity-backend-app-c617ceee667d.herokuapp.com";

    addLog(`Testing CORS with backend at ${baseURL}`);

    try {
      // Test with credentials mode first
      addLog("TEST 1: Testing /test-cors-api/ endpoint WITH credentials...");
      const responseWithCredentials = await axios.get(
        `${baseURL}/test-cors-api/`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Origin: window.location.origin,
          },
        }
      );

      addLog(
        `Success! WITH credentials response: ${JSON.stringify(
          responseWithCredentials.data
        )}`
      );
      setResults((prev) => ({
        ...prev,
        withCredentials: responseWithCredentials.data,
      }));

      // Now test without credentials
      addLog("TEST 2: Testing /test-cors-api/ endpoint WITHOUT credentials...");
      const responseWithoutCredentials = await axios.get(
        `${baseURL}/test-cors-api/`,
        {
          withCredentials: false,
          headers: {
            "Content-Type": "application/json",
            Origin: window.location.origin,
          },
        }
      );

      addLog(
        `Success! WITHOUT credentials response: ${JSON.stringify(
          responseWithoutCredentials.data
        )}`
      );
      setResults((prev) => ({
        ...prev,
        withoutCredentials: responseWithoutCredentials.data,
      }));

      // Now try the public-settings endpoint (the one used in the app)
      addLog(
        "TEST 3: Testing /api/public-settings/ endpoint WITH credentials..."
      );
      const settingsResponse = await axios.get(
        `${baseURL}/api/public-settings/`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Origin: window.location.origin,
          },
        }
      );

      addLog(
        `Public settings success! Got ${
          Object.keys(settingsResponse.data).length
        } settings`
      );
    } catch (err) {
      addLog(`Error: ${err.message}`);
      console.error("CORS Test Error:", err);
      setError(err.message);

      // Add more detailed error info
      if (err.response) {
        addLog(`Response status: ${err.response.status}`);
        addLog(`Response data: ${JSON.stringify(err.response.data)}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>CORS Test</h1>

      <button
        onClick={testCors}
        style={{
          padding: "10px 15px",
          background: "#4CAF50",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        Run CORS Test
      </button>

      <div style={{ marginBottom: "20px" }}>
        <h2>Status</h2>
        {loading ? (
          <p>Testing CORS...</p>
        ) : error ? (
          <div
            style={{
              color: "red",
              padding: "10px",
              background: "#ffebee",
              borderRadius: "4px",
            }}
          >
            <h3>Error</h3>
            <p>{error}</p>
          </div>
        ) : (
          <div>
            <div
              style={{
                color: "green",
                padding: "10px",
                background: "#e8f5e9",
                borderRadius: "4px",
                marginBottom: "10px",
              }}
            >
              <h3>Test with credentials:</h3>
              {results.withCredentials ? (
                <pre>{JSON.stringify(results.withCredentials, null, 2)}</pre>
              ) : (
                <p>No results yet</p>
              )}
            </div>

            <div
              style={{
                color: "green",
                padding: "10px",
                background: "#e8f5e9",
                borderRadius: "4px",
              }}
            >
              <h3>Test without credentials:</h3>
              {results.withoutCredentials ? (
                <pre>{JSON.stringify(results.withoutCredentials, null, 2)}</pre>
              ) : (
                <p>No results yet</p>
              )}
            </div>
          </div>
        )}
      </div>

      <div>
        <h2>Logs</h2>
        <div
          style={{
            height: "300px",
            overflowY: "auto",
            background: "#f5f5f5",
            padding: "10px",
            borderRadius: "4px",
            fontFamily: "monospace",
            fontSize: "14px",
          }}
        >
          {logs.map((log, index) => (
            <div key={index} style={{ marginBottom: "5px" }}>
              {log}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CorsTest;
